import { Shimmer } from '@components';

import { Content, Spacing } from './IdentificationRequests.styles';

const TableContentLoading = () => {
  return (
    <Content>
      <Spacing>
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4, marginTop: 8 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4, marginTop: 8 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
      </Spacing>
    </Content>
  );
};

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 18, width: 18, borderRadius: 4, marginLeft: 12 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export { TableContentLoading, CountLoading };
